import React from 'react';
import get from 'lodash/get';
import { StyledFormItem, StyledParagraph } from './styles';
import { getCountryCodes } from '@xbcb/ui-utils';
import { useQuery } from '@apollo/client';
import { getOneQuery, getRecordFromResponse } from '@xbcb/shared-queries';
import { getRecordType } from '@xbcb/core';
import { addressesFields } from '@xbcb/party-queries';
import { RecordType } from '@xbcb/shared-types';

type LocationSummaryProps = {
  recordId: string;
  maintainHeight?: boolean;
  $removeSpaceBottom?: boolean;
};

const LocationSummary = ({
  recordId,
  maintainHeight,
  $removeSpaceBottom = true,
}: LocationSummaryProps) => {
  const countryCodes = getCountryCodes();

  const spacer = maintainHeight && <StyledParagraph>text</StyledParagraph>;

  const recordType = getRecordType(recordId) as RecordType; // getRecordType returns string type right now.

  const getQuery = getOneQuery({
    recordName: recordType,
    fields: '...addressesFields',
    fragments: addressesFields,
  });
  const queryResponse = useQuery(getQuery, {
    variables: { id: recordId },
  });
  const record = getRecordFromResponse(queryResponse, 'get', recordType);
  const { address, countryCode, stateCode, postalCode, city } =
    record?.addresses?.mailing || record?.addresses?.physical || {};

  return (
    <StyledFormItem $readOnly $removeSpaceBottom={$removeSpaceBottom}>
      {address ? <p>{address}</p> : spacer}
      {countryCode || stateCode || postalCode || city ? (
        <p>
          {city}{' '}
          {stateCode && countryCode && countryCode === 'US'
            ? stateCode
            : get(countryCodes, [
                countryCode,
                'subdivision',
                stateCode,
                'name',
              ])}{' '}
          {postalCode}{' '}
          {countryCode && countryCode === 'US'
            ? countryCode
            : get(countryCodes, [countryCode, 'name'])}
        </p>
      ) : (
        spacer
      )}
    </StyledFormItem>
  );
};

export default LocationSummary;
